module.exports = "<div class=\"container\">\n  <h1>Something went wrong.</h1>\n  <p>We can't find the page you are looking for.</p>\n  <p><a href=\"/\">Return to home.</a></p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found.component.html
// module chunks = main